export default __webpack_public_path__ + "static/media/favorite_border_24dp.e0f3e7ea.svg";